module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__cl_banco_estado_Min.7b09c393.svg";